module.exports = __webpack_public_path__ + "static/media/checkmark_white.70222d4c.svg";